import toast from "react-hot-toast";


//IMPORTANTE: 
// Los toast comentados fueron creador para debuggear el proceso de obtencion de coordenadas.
// Si por alguna razon se necesita debuggear nuevamente, descomentar los toast para tener feedback visual de cada paso y error.

const obtenerConGetCurrent = () =>
    new Promise((resolve, reject) => {
        const timeoutMs = 10000;

        const timeoutId = setTimeout(() => {
            reject({ code: 3, message: "Timeout externo getCurrentPosition" });
        }, timeoutMs + 500);

        navigator.geolocation.getCurrentPosition(
            ({ coords }) => {
                clearTimeout(timeoutId);
                // toast.success("Coordenadas obtenidas con getCurrentPosition");
                resolve({ latitud: coords.latitude, longitud: coords.longitude });
            },
            (error) => {
                clearTimeout(timeoutId);
                // toast.error(`getCurrentPosition error - code: ${error.code} - ${error.message}`);
                reject(error);
            },
            {
                timeout: timeoutMs,
                maximumAge: 30000,
                enableHighAccuracy: true,
            }
        );
    });

const obtenerConWatch = () =>
    new Promise((resolve, reject) => {
        const timeoutMs = 15000;
        let watchId = null;

        const timeoutId = setTimeout(() => {
            navigator.geolocation.clearWatch(watchId);
            reject({ code: 3, message: "Timeout externo watchPosition" });
        }, timeoutMs + 500);

        watchId = navigator.geolocation.watchPosition(
            ({ coords }) => {
                clearTimeout(timeoutId);
                navigator.geolocation.clearWatch(watchId);
                // toast.success("Coordenadas obtenidas con watchPosition");
                resolve({ latitud: coords.latitude, longitud: coords.longitude });
            },
            (error) => {
                clearTimeout(timeoutId);
                navigator.geolocation.clearWatch(watchId);
                // toast.error(`watchPosition error - code: ${error.code} - ${error.message}`);
                reject(error);
            },
            {
                timeout: timeoutMs,
                maximumAge: 60000,
                enableHighAccuracy: false, // Baja precisión para mayor compatibilidad
            }
        );
    });

export const obtenerCoordenadas = async () => {
    try {
        if (!("geolocation" in navigator)) {
            // toast.error("geolocation is not in navigator");
            return { latitud: null, longitud: null };
        }

        if ("permissions" in navigator) {
            try {
                const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
                // toast(`Permission state: ${permissionStatus.state}`); // ← debug
                if (permissionStatus.state === "denied") {
                    // toast.error("permission denied for geolocation");
                    return { latitud: null, longitud: null };
                }
            } catch (e) {
                // toast.error(`Permissions API error: ${e?.message}`); 
            }
        }

        try {
            return await obtenerConGetCurrent();
        } catch (errorGetCurrent) {
            // toast.error(`getCurrentPosition falló - code: ${errorGetCurrent.code} - ${errorGetCurrent.message}`);
        }

        try {
            return await obtenerConWatch();
        } catch (errorWatch) {
            // toast.error(`watchPosition falló - code: ${errorWatch.code} - ${errorWatch.message}`);
            return { latitud: null, longitud: null };
        }

    } catch (fatalError) {
        // toast.error(`Error inesperado en obtenerCoordenadas: ${fatalError?.message}`);
        return { latitud: null, longitud: null };
    }
};